import { ILaunchDateValues } from 'src/types/ILaunchDates';

export const defaultLaunchDateValues: ILaunchDateValues = {
    serviceID: '',
    territoryID: '',
    launchDate: '',
    endDate: '',
    serviceName: '',
    territoryCode: '',
    launchToBeDeactivated: ''
};
